import { configureStore } from "@reduxjs/toolkit";
import SearchModalReducer from "./slices/searchModalSlice";
import sidebarReducer from "./slices/sidebarSlice";
import deleteConfirmModalReducer from "./slices/deleteConfirmModal";

export const store = configureStore({
  reducer: {
    searchModal: SearchModalReducer,
    sidebar: sidebarReducer,
    deleteConfirmModal: deleteConfirmModalReducer,
  },
});

export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore["dispatch"];
